var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',{staticClass:"text-center mb-6",attrs:{"flat":"","color":"primary"}},[_c('v-toolbar-title',[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }